import { createFileRoute, redirect } from '@tanstack/react-router';

import { organizationSettingsEntries } from '@/areas/settings/OrganizationSettings/useOrganizationSettingsEntries';
import { canOpenRoute } from '@/shared/permissions/PagePermissionContext';
import type { PageStaticData } from '@/shared/routing';

// Opens the first page the settings menu offers this user, so "Settings" in the command palette lands on content, not
// an empty pane. The menu shows a link by its page's access, so this asks the same. Without a link the
// `settings/_menu` layout renders the menu alone, which no user reaches today: the Account security link at its end
// is hidden by no permission.
export const Route = createFileRoute('/_authenticated/settings/_menu/organization/')({
    staticData: { access: { permissions: ['view:organization_settings'] }, chrome: 'home' } satisfies PageStaticData,
    beforeLoad: ({ context }) => {
        const firstLink = organizationSettingsEntries(context.session)
            .filter((entry) => entry.type === 'link')
            .find((entry) => canOpenRoute(context.session, context.routeChainOf(entry.link)));
        if (firstLink !== undefined) {
            throw redirect({ ...firstLink.link, replace: true });
        }
    },
});
